import ePower from '../views/ePower'

export default {
  path: '/ePower',
  component: ePower,
  redirect: '/ePower/lifeInfo',
  name: 'ePower',
  meta: {
    title: '订单管理'
  },
  children: [
    {
      path: '/ePower/lifeInfo',
      component: () => import('../views/ePower/LifeInfo'),
      name: 'LifeInfo',
      meta: { title: '订单列表' }
    },
    {
      path: '/ePower/education',
      component: () => import('../views/ePower/Education'),
      name: 'Education',
      meta: { title: '派单列表' }
    },
    {
      path: '/ePower/partyBuilding',
      component: () => import('../views/ePower/PartyBuilding'),
      name: 'PartyBuilding',
      meta: { title: '物流列表' }
    },
    {
      path: '/ePower/connection',
      component: () => import('../views/ePower/Connection'),
      name: 'Connection',
      meta: { title: '订单列表' }
    },
    {
      path: '/ePower/ordersh',
      component: () => import('../views/ePower/Ordersh'),
      name: 'Ordersh',
      meta: { title: '售后订单' }
    },
    {
      path: '/ePower/orderdz',
      component: () => import('../views/ePower/Orderdz'),
      name: 'Orderdz',
      meta: { title: '收货地址' }
    }

  ]
}
